import NextImage from 'next/image'
import { Tile, TileImage, TileOverlay } from '@mc/design-system'
import { cloudflareLoader } from '@mc/image-cloudflare'
import { BREAKPOINTS } from '@mc/media'
import { useStaticData } from '@mc/static-data-react'
import { PrunedCourse } from 'libs/server/api'
import classes from './Hero.module.scss'

export const MobileBackgroundImage = () => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  return (
    <div className={classes.mobileImageContainer}>
      {course.image16x9 && (
        <Tile>
          <TileImage
            image={
              <NextImage
                src={course.image16x9}
                alt=''
                loader={cloudflareLoader}
                layout='fill'
                sizes={`(max-width: ${BREAKPOINTS.MD + 1}px) 100vw, 0vw`}
                objectFit='contain'
                objectPosition='top'
                priority
              />
            }
          />
          <div className={classes.blurOverlay} />
        </Tile>
      )}
    </div>
  )
}

// Desktop and Tablet
export const DesktopBackgroundImage = () => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  return (
    <>
      {course?.cinematic12x5 && (
        <TileImage
          image={
            <NextImage
              src={course.cinematic12x5}
              alt=''
              loader={cloudflareLoader}
              layout='fill'
              // Desktop image is visible at MD breakpoint and above
              sizes={`(max-width: ${BREAKPOINTS.MD - 1}px) 0vw, 100vw`}
              objectFit='cover'
              priority
            />
          }
        />
      )}
      <TileOverlay color='0,0,0' />
    </>
  )
}
